import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { onMobile } from '../styles/breakpoints';
import { tableCheckboxCss, tableMobileCss } from './Table.styled';
import { thHiddenCss } from './TH.styled';
export var StyledTHead = styled.thead(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\t", "\n"])), tableMobileCss);
var theadHiddenCss = function theadHiddenCss(props) {
  return props.isHidden && css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n\t\tvisibility: hidden;\n\t"])));
};
export var StyledTHeadTR = styled.tr(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n\twhite-space: nowrap;\n\t", " {\n\t\tdisplay: none;\n\t}\n\t", ";\n"])), onMobile, theadHiddenCss);
export var StyledTHCheckboxWrapper = styled.th(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n\t", ";\n\t", ";\n"])), tableCheckboxCss, thHiddenCss);
export var StyledTHCheckbox = styled.span(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n\tdisplay: ", ";\n"])), function (props) {
  return props.isHidden ? 'none' : 'inline';
});